/** Created by azhou on 2019/3/26.*/
<template>
  <div>
    <public-title>酒店活动审核</public-title>
    <div class="load-area">
      <el-tabs v-model="activeName" @tab-click="$GFUN.pageChange(1);getDataLists()">
        <el-tab-pane :name="item.id" v-for="item in tabArr" :key="item.id">
          <label slot="label">{{item.name}}
            <span class="unread-msg" v-if="waitVerify.hotelActi>0 && item.name==='未审核'">{{waitVerify.hotelActi}}</span>
          </label>
        </el-tab-pane>
      </el-tabs>
      <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
      <div v-else>
        <ul class="list-head mt-3"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
          <li class="w-50 list-item-col">
            <span class="text-link" @click="goStoreDetail(item.main_id)">{{item.hotelTitle}}</span>
          </li>
          <li class="w-50 list-item-col">{{item.title | formatString(8)}}</li>
          <li class="w-50 list-item-col">{{item.startdate | formatTimestamp(1)}}</li>
          <li class="w-50 list-item-col">{{item.enddate | formatTimestamp(1)}}</li>
          <li class="w-50 list-item-col">{{item.time | formatTimestamp(1)}}</li>
          <li class="w-50 list-item-col-end flex-wrap">
            <span class="text-link" @click="verifyItem(item)">{{activeName==='0'?'去审核':'查看'}}</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                       @current-change="$GFUN.pageChange"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapActions,mapState } from 'vuex'

  export default {
    name: 'VerifyHotelActi',
    computed: {
      ...mapState(['AdminDataLists','waitVerify']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
    },
    watch:{
      queryCon() { this.getDataLists(); },
    },
    data() {
      return {
        activeName:'0',
        titleArr:['酒店名称','标题','开始时间','结束时间','申请时间','操作'],
        tabArr:[{name:'未审核',id:'0'},{name:'已审核',id:'1'},{name:'已拒绝',id:'2'}]
      }
    },
    created() { this.getDataLists(); },
    methods:{
      ...mapActions(['getAdminDataLists']),
      getDataLists() {
        this.getAdminDataLists({
          type:'hotelActi',
          data:{
            ...this.queryCon,
            status: this.activeName,
          }
        });
      },
      //查看酒店详情
      goStoreDetail(id) {
        this.$router.push({name:'StoreDetail',query:{type:3,id}})
      },
      //去审核
      verifyItem(item) {
        if (!this.$GFUN.powerIsInArray([118])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({
          name:'addEditDiscount',
          query:{
            store:item.main_id,
            discount:item.id
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .unread-msg{
    top: 5px;
    left: 48px;
  }
</style>
